module.exports = __webpack_public_path__ + "img/sld_mppt_2_t1_b1.5c1c6a0a.svg";